import { FormEventHandler, useState } from "react";
import { useRouteLoaderData } from "react-router";

import { Button, Card, Heading, Span, UiIcon } from "@icg360/design-system";

import { AppLoaderData } from "../../../types";
import styles from "./OrderSummary.module.css";

interface OrderSummaryProps {
  isLoading: boolean;
  isDisabled: boolean;
  price: string;
  collapsible?: boolean;
  onSubmitPayment: FormEventHandler;
}

export const OrderSummary = ({
  isLoading,
  isDisabled,
  price,
  collapsible,
  onSubmitPayment
}: OrderSummaryProps) => {
  const quote = useRouteLoaderData<AppLoaderData>("root")!;
  const [collapsed, setCollapsed] = useState(true);

  return (
    <Card className={styles.summaryCard}>
      <div className={styles.headerWrapper}>
        {collapsible ? (
          <button
            onClick={() => setCollapsed(!collapsed)}
            className={styles.collapsibleIcon}
          >
            <Heading size="md">Order summary</Heading>
            <UiIcon name={collapsed ? "ArrowUp" : "ArrowDown"} />
          </button>
        ) : (
          <Heading size="md">Order summary</Heading>
        )}
      </div>
      {/* the onclick is the div is ok because the same action is on the button above */}
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div
        className={styles.summaryItems}
        onClick={() => collapsible && setCollapsed(!collapsed)}
      >
        <div className={styles.lineItem}>
          <Span>LiftLock’s Shingle Resealing Service</Span>
          <Span>{`$${+price}`}</Span>
        </div>
        <div className={collapsed ? styles.collapsed : ""}>
          <div className={styles.address}>
            <Span size="sm" color="quiet">
              Service address:
            </Span>
            <Span size="sm" color="quiet">
              {quote?.sectionFieldsMap?.customerAddress}
            </Span>
          </div>
          <div>
            <Span size="sm" color="quiet">
              Quote #: {quote.quoteNumber}
            </Span>
          </div>
          <div className={styles.lineItem}>
            <Span>Subtotal</Span>
            <Span>{`$${+price}`}</Span>
          </div>
          <div className={styles.lineItem}>
            <Span>Tax</Span>
            <Span>$0</Span>
          </div>
        </div>
      </div>
      <Button
        data-testid="paymentButton"
        className={`${styles.paymentButtonDS} ${!isDisabled ? styles.llColorsDS : ""}`}
        isDisabled={isDisabled}
        loading={isLoading}
        onClick={onSubmitPayment}
        fluid
      >
        Purchase
      </Button>
      <div className={styles.secureCheckout}>
        <Span size="sm" color="quiet">
          Secure SSL checkout
        </Span>
      </div>
    </Card>
  );
};
